import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Badge } from "primereact/badge";
import OccupancyRate from "../front modules/OccupancyRate";
import countries from "../data/country.json";
import formlabels from "../data/formlabels.json";

const Stats = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://chartrespilgerverein.ch/backend/form_data.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const jsonData = await response.json();
        setData(jsonData.data);
      } catch (error) {
        console.error("❌ Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!data) return <p>No data available.</p>;

  return (
    <div className="card">
      <TabView>
        <TabPanel header="Chapitres">
          <div className="grid">
            {data.chapitres.map((chapitre, index) => (
              <div key={index} className="col-12 md:col-6 lg:col-4">
                <div className="p-3 shadow-1 border-round surface-card">
                  <h4 className="flex justify-content-between align-items-center">
                    {chapitre.name}

                  </h4>
                  {chapitre.maxPeople && (
                    <div>
                      {OccupancyRate(
                        chapitre.maxPeople,
                        chapitre.totalPeople,
                        chapitre.totalWaitlist,
                        "Occupancy Rate",
                        formlabels['en'].almostFullWarning
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </TabPanel>

        <TabPanel header="Buses">
          <div className="grid">
            {data.buslines.map((bus, index) => (
              <div key={index} className="col-12 md:col-6 lg:col-4">
                <div className="p-3 shadow-1 border-round surface-card">
                  <h4 className="flex justify-content-between align-items-center">
                    {bus.name} {countries[bus.country]?.emoji}

                  </h4>
                  {bus.maxSeats && (
                    <div className="flex flex-column gap-3">
                      {OccupancyRate(
                        bus.maxSeats,
                        bus.totalOneway,
                        bus.totalOnewayWaitList,
                        "To Paris",
                        formlabels['en'].almostFullWarning
                      )}
                      {OccupancyRate(
                        bus.maxSeats,
                        bus.totalReturn,
                        bus.totalReturnWaitList,
                        "From Chartres",
                        formlabels['en'].almostFullWarning
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
};

export default Stats;
